import { useEffect, useState } from "react";

/**
 * useDebounce Hook
 * @param value - The value to debounce (e.g. search text)
 * @param delay - The delay time in ms (default: 500)
 */
export function useDebounce<T>(value: T, delay: number = 500): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay);

    return () => {
      clearTimeout(handler); // clear previous timer
    };
  }, [value, delay]);

  return debouncedValue;
}
